import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.css";
import { useParams } from "react-router-dom";
import { token_api } from "../../Utils/Network";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  Divider,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { UserCredsContext } from "../../ContextApis/UserCredsContext/UserCredsContext";
import { findObject } from "../../Utils/Utils";
import EditIcon from "@mui/icons-material/Edit";
import SchoolIcon from "@mui/icons-material/School";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import EditFieldsForm from "../Students/EditFieldsForm";
import styled from "@emotion/styled";
import CustomStudentProfile from "../../Components/CustomStudentProfile/CustomStudentProfile";
import CustomConcern from "../../Components/CustomConcern/CustomConcern";
import CustomDreamCareer from "../../Components/CustomDreamCareer/CustomDreamCareer";
import CustomJudgementTwo from "../../Components/CustomJudgementTwo/CustomJudgementTwo";
import CustomRecommendationTwo from "../../Components/CustomRecommendationTwo/CustomRecommendationTwo";
import DynamicCategorySection from "./DynamicCategorySection";
import GenericCategoryComponent from "./GenericCategoryComponent";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

/**
 * The report a session uses without the counsellor picking one: a report of
 * the session's package, matched on which session of that package this is
 * (1st session -> report 1, 2nd -> report 2 ...). With fewer reports than
 * sessions, a later session keeps the last report that applies by then.
 * @returns {number|null} report template id
 */
const autoReportFor = (session, sessions, templates) => {
  if (!session.package) return null;
  const forPackage = templates
    .filter((t) => t.package === session.package)
    .sort((a, b) => a.report_number - b.report_number);
  if (!forPackage.length) return null;
  const samePackage = sessions
    .filter((s) => s.package === session.package)
    .sort((a, b) => a.id - b.id);
  const position = samePackage.findIndex((s) => s.id === session.id) + 1;
  const upToHere = forPackage.filter((t) => t.report_number <= position);
  return (upToHere.length ? upToHere[upToHere.length - 1] : forPackage[0]).id;
};

const StudentProfile = () => {
  const { sid } = useParams();
  const [details, setDetails] = useState({});
  const [que, setQue] = useState([]);
  const [sessionAnswers, setSessionAnswers] = useState({});
  const [areaQue, setAreaQue] = useState([]);
  const [areaAns, setAreaAns] = useState({});
  const [dreamQue, setDreamQue] = useState([]);
  const [dreamAns, setDreamAns] = useState({});
  const [judgementQue, setjudgementQue] = useState([]);
  const [judgementAns, setjudgementAns] = useState({});
  const [recommQue, setRecommQue] = useState([]);
  const [recommAns, setRecommAns] = useState({});
  const [expandedAccordion, setExpandedAccordion] = useState(false);
  // Which report the counsellor is writing, per session: session 1 can be an
  // EXPLORE report while session 2 is a career one, so this is keyed by
  // session id rather than held as a single value for the whole student.
  const [reports, setReports] = useState([]);
  const [sessionReport, setSessionReport] = useState({});
  const [sessionGeneratedReports, setSessionGeneratedReports] = useState({});
  const [sessionCategories, setSessionCategories] = useState({});
  const [gradeId, setGradeId] = useState(null);
  const [sectionType, setSectionType] = useState(editSection[0]);
  const { gradeList, instituteList } = useContext(UserCredsContext);
  const [open, setOpen] = useState(false);
  const [editObject, setEditObject] = useState({});
  const [objForForm, setObjForForm] = React.useState({});
  const [testDet, setTestDet] = useState([]);

  const [testResponce, setTestResponce] = useState("");
  const [areaResponce, setAreaResponce] = useState("");
  const [dreamResponce, setDreamResponce] = useState("");
  const [judgResponce, setJudgResponce] = useState("");
  const [recoResponce, setRecoResponce] = useState("");
  const [categoryQuestions, setCategoryQuestions] = useState({});
  const [categoryAnswers, setCategoryAnswers] = useState({});
  // AI text of ai=True sections, keyed "<sessionId>-<categoryId>".
  const [aiTexts, setAiTexts] = useState({});
  // Earlier sessions of the same package, per session id - read by the
  // counsellor before writing a follow-up (Transform sessions 2 and 3).
  const [sessionHistory, setSessionHistory] = useState({});
  // What the student said at booking, per session: { note, prefilled }.
  // `prefilled` means some section's ticks came from the booking, not a save.
  const [sessionIntake, setSessionIntake] = useState({});
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  // Map category title to custom component if needed
  const customComponentMap = {
    "Student Profile": CustomStudentProfile,
    "Area of concern": CustomConcern,
    "Dream Career Details": CustomDreamCareer,
    Judgement: CustomJudgementTwo,
    Recommendation: CustomRecommendationTwo,
    default: GenericCategoryComponent,
  };

  useEffect(() => {
    if (sid) {
      getStudentDetails(sid);
    }
  }, [sid]);

  const getStudentDetails = (id) => {
    // const response = await token_api.get(`/counseling/get_user_deta/${id}`);
    token_api
      .get(`/counseling/get_user_deta/${id}`)
      .then((response) => {
        const studentData = response?.data?.data;
        setDetails(studentData);
        setObjForForm(studentData);
        setTestResponce(studentData?.extra_info?.student_profile);
        setAreaResponce(studentData?.extra_info?.area_of_concern);
        setDreamResponce(studentData?.extra_info?.dream_career);
        setJudgResponce(studentData?.extra_info?.judgment);
        setRecoResponce(studentData?.extra_info?.recommendation);
        const studentGrade = studentData?.profile?.grade?.id;
        setGradeId(studentGrade);

        // Each session opens on its report: the one already started for it,
        // otherwise the one its package calls for. Needs the report list
        // first, hence the wait.
        const sessions = studentData?.sessions || [];
        // Opened from the Reports page: unfold that session.
        const wanted = new URLSearchParams(window.location.search).get("session");
        const wantedIndex = sessions.findIndex((s) => String(s.id) === wanted);
        if (wantedIndex >= 0) setExpandedAccordion(wantedIndex);
        fetchReports().then((templates) => {
          const initialReports = {};
          const initialGenReports = {};
          sessions.forEach((s) => {
            if (s.session_report) {
              initialGenReports[s.id] = s.session_report;
            }
            const reportId =
              s.session_report?.report_template ||
              autoReportFor(s, sessions, templates);
            if (reportId) {
              initialReports[s.id] = reportId;
              fetchCategoriesAndQuestions(studentGrade, reportId, s.id);
            }
          });
          setSessionGeneratedReports((prev) => ({ ...initialGenReports, ...prev }));
          setSessionReport((prev) => ({ ...initialReports, ...prev }));
        });

        token_api
          .get(`/counseling/test_result/?user_id=${id}`)
          .then((response) => setTestDet(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCategoriesAndQuestions = async (studentGrade, reportId, sessionId) => {
    // No report chosen yet means no sections: picking one is what decides
    // which questions the counsellor is asked.
    if (!reportId) {
      setSessionCategories((prev) => ({ ...prev, [sessionId]: [] }));
      return;
    }
    const res = await token_api.get(
      `counseling/v1/counseling_categories?report=${reportId}`
    );
    setSessionCategories((prev) => ({ ...prev, [sessionId]: res.data.data }));
    token_api
      .get(`counseling/v1/session_report/previous_sessions/?session_id=${sessionId}`)
      .then((hRes) => {
        const history = hRes?.data?.data || hRes?.data || {};
        setSessionHistory((prev) => ({ ...prev, [sessionId]: history }));
      })
      .catch((err) => console.error("Could not load earlier sessions:", err));
    res.data.data.forEach(async (cat) => {
      // Questions depend only on category + grade, so they are cached once and
      // shared by every session that picks the same report.
      if (!categoryQuestions[cat.id]) {
        const qRes = await token_api.get(
          `/counseling/v1/counseling_questions?category=${cat.id}&grade=${studentGrade}`
        );
        setCategoryQuestions((prev) => ({ ...prev, [cat.id]: qRes.data.data }));
      }

      // Load previously saved answers for this session and category
      try {
        const aRes = await token_api.get(
          `/counseling/v1/counseling_questions/get_session_answers/?session_id=${sessionId}&category_id=${cat.id}`
        );
        if (aRes?.data?.data) {
          setCategoryAnswers((prev) => ({
            ...prev,
            [cat.id]: {
              ...(prev[cat.id] || {}),
              [sessionId]: aRes.data.data,
            },
          }));
        }
        if (aRes?.data?.ai_text) {
          setAiTexts((prev) => ({ ...prev, [`${sessionId}-${cat.id}`]: aRes.data.ai_text }));
        }
        if (aRes?.data?.intake_note || aRes?.data?.prefilled_from_booking) {
          setSessionIntake((prev) => ({
            ...prev,
            [sessionId]: {
              note: aRes.data.intake_note || prev[sessionId]?.note || "",
              prefilled: Boolean(prev[sessionId]?.prefilled || aRes.data.prefilled_from_booking),
            },
          }));
        }
      } catch (err) {
        console.log("Error loading previous answers", err);
      }
    });
  };

  const fetchReports = async () => {
    const res = await token_api.get(`counseling/v1/counseling_categories/reports/`);
    const list = res.data.data || res.data || [];
    setReports(list);
    return list;
  };

  // Only the reports of the packages this student bought, plus reports not
  // tied to any package. A student with no package sees every report, and the
  // report already chosen for a session always stays in its list.
  const reportsForStudent = (sessionId) => {
    const bought = (details?.packages || []).map((p) => p.package_id).filter(Boolean);
    if (!bought.length) return reports;
    return reports.filter(
      (r) => !r.package || bought.includes(r.package) || r.id === sessionReport[sessionId]
    );
  };

  const handleReportChange = (sessionId, reportId) => {
    setSessionReport((prev) => ({ ...prev, [sessionId]: reportId }));
    fetchCategoriesAndQuestions(gradeId, reportId, sessionId);
  };

  const handleCategoryAnswerChange = (
    categoryId,
    sessionId,
    questionId,
    choice,
    answer
  ) => {
    setCategoryAnswers((prev) => {
      const prevSession = prev[categoryId]?.[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );
      // A multi-select question sends an array of choice ids; keep it under
      // `choices` so the single-select `choice` contract stays untouched.
      const entry = Array.isArray(choice)
        ? { question: questionId, choices: choice, answer }
        : { question: questionId, choice, answer };
      return {
        ...prev,
        [categoryId]: {
          ...prev[categoryId],
          [sessionId]: [...updatedSession, entry],
        },
      };
    });
  };

  const saveCategoryAnswers = (categoryId, sessionId) => {
    // debugger;
    setLoading(true);
    const payload = {
      session_id: sessionId,
      // Lets a section be submitted with nothing filled in (Goal Setting is
      // then written from the client's concerns).
      category_id: categoryId,
      data: categoryAnswers[categoryId]?.[sessionId] || [],
    };
    token_api
      .post(
        `/counseling/v1/counseling_questions/save_question_answers/`,
        payload
      )
      .then((res) => {
        if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
          if (categoryId === 1) {
            setTestResponce(res?.data?.data?.response || res?.data?.response);
          } else if (categoryId === 2) {
            setAreaResponce(res?.data?.data?.response || res?.data?.response);
          } else if (categoryId === 3) {
            setDreamResponce(res?.data?.data?.response || res?.data?.response);
          } else if (categoryId === 4) {
            setJudgResponce(res?.data?.data?.response || res?.data?.response);
          } else if (categoryId === 5) {
            setRecoResponce(res?.data?.data?.response || res?.data?.response);
          }
          // ai_text is only sent when the AI actually wrote the section.
          const aiText = res?.data?.ai_text;
          if (aiText) {
            setAiTexts((prev) => ({ ...prev, [`${sessionId}-${categoryId}`]: aiText }));
          }
          const section = (sessionCategories[sessionId] || []).find((c) => c.id === categoryId);
          setLoading(false);
          alert(
            section?.ai && !aiText
              ? "Answers saved, but the AI could not write this section. The report will use the chosen options instead; try submitting again."
              : "Answers saved successfully!"
          );
        } else {
          setLoading(false);
          alert("Something went wrong while saving.");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Save error:", err);
        alert(err?.response?.data?.response || "Something went wrong while saving.");
      })
      .finally(() => {
        setLoading(false);
        // alert("Something went wrong");
      });
  };
  console.log(categoryAnswers, categoryQuestions, "3o9qwdsuhijklqwdj");
  const handleAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setSessionAnswers((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handleareaAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setAreaAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };
  const handleDreamAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setDreamAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handlejudgementAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setjudgementAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handleRecomAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setRecommAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };
  // console.log(sessionAnswers, "wemrpf9idujksdfajdks");
  const handleClickOpen = (string, objForEdit) => {
    setOpen(true);
    // setStateForEdit(id);
    const retObj = findObject(editSection, string, "type");
    console.log("ret", retObj);

    setSectionType(retObj);
    setEditObject(objForEdit);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // test pdf api

  const openTestPdf = (e, id, testtype) => {
    // console.log("idpdf", id);
    // console.log("typepdf",testtype);

    token_api
      .get(`/counseling/overall_result/?user_id=${id}&test_type=${testtype}`)
      .then((response) => {
        console.log(response.data.data.pdf);
        response.data.data.pdf
          ? window.open(response.data.data.pdf)
          : alert("User has not given the test");
      });
  };

  const buildPayloadForSession = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: sessionAnswers[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setTestResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };

  const areaOfConcern = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: areaAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setAreaResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const dreamCareer = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: dreamAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setDreamResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const judgement = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: judgementAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setJudgResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const recommendation = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: recommAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setRecoResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };

  // downloade test

  const handleGenerateSessionReport = (sessionId, userId) => {
    setLoading(true);
    // The report picked on screen, so a changed one is the one printed.
    const chosen = sessionReport[sessionId] ? `&report_template=${sessionReport[sessionId]}` : "";
    token_api
      .get(
        `/counseling/v1/session_report/generate_session_pdf/?session_id=${sessionId}&user_id=${userId}${chosen}`
      )
      .then((response) => {
        setLoading(false);
        const fileUrl =
          response?.data?.file ||
          response?.data?.data?.file ||
          response?.data?.report_pdf;
        if (fileUrl) {
          const reportTemplateId =
            response?.data?.report_template || sessionReport[sessionId];
          const templateObj = reports.find((r) => r.id === reportTemplateId);
          const genData = {
            id: response?.data?.id,
            report_template: reportTemplateId,
            report_template_name:
              response?.data?.report_template_name ||
              templateObj?.title ||
              "Counselling Report",
            report_pdf: fileUrl,
            status: response?.data?.status || 1,
            created: response?.data?.created || "Just now",
          };
          setSessionGeneratedReports((prev) => ({
            ...prev,
            [sessionId]: genData,
          }));
          if (reportTemplateId) {
            setSessionReport((prev) => ({
              ...prev,
              [sessionId]: reportTemplateId,
            }));
          }
          window.open(fileUrl, "_blank");
        } else {
          alert("Error! Report file could not be found.");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        alert(err?.response?.data?.detail || "Error! Report cannot be generated");
      });
  };

  const handleCareerCounsellingReport = (userId, reportType) => {
    console.log("CareerResporttyepe", reportType);

    // If counsellor is writing a session report (e.g. EXPLORE report), generate that report
    const activeSessionId = Object.keys(sessionReport).find(
      (sId) => sessionReport[sId]
    );
    if (activeSessionId) {
      handleGenerateSessionReport(activeSessionId, userId);
      return;
    }
    // If sessions exist, use first session
    const firstSessionId = details?.sessions?.[0]?.id;
    if (firstSessionId) {
      handleGenerateSessionReport(firstSessionId, userId);
      return;
    }

    if (reportType == false) {
      // call online
      setLoading(true);
      token_api
        .get(
          `/counseling/career/report/career_counselling_report/?user_id=${userId}`
        )
        .then((response) => {
          setLoading(false);
          console.log("pdfResponse", response);
          const fileUrl = response?.data?.file || response?.data?.data?.file;
          if (fileUrl) {
            window.open(fileUrl, "_blank");
          } else {
            alert("Error! Report does not exist");
          }
        })
        .catch((err) => {
          setLoading(false);
          alert("Error!Report cannot be generated");
        });
    } else if (reportType == true) {
      // call offline
      setLoading(true);
      token_api
        .get(
          `counseling/career/report/career_counselling_offline_report/?user_id=${userId}`
        )
        .then((response) => {
          setLoading(false);
          console.log("OfflineResport", response);
          const fileUrl = response?.data?.file || response?.data?.data?.file;
          if (fileUrl) {
            window.open(fileUrl, "_blank");
          } else {
            alert("Error! Report does not exist");
          }
        })
        .catch((err) => {
          setLoading(false);
          alert("Error! Report does not exist");
        });
    }
  };


  return (
    <Box sx={{ width: "100%", maxWidth: "1280px", margin: "0 auto", padding: "8px 16px 80px 16px" }}>
      {/* Student Profile Hero Card */}
      <Card
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
          padding: "24px 28px",
          marginBottom: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
            borderBottom: "1px solid #f1f5f9",
            pb: 2.5,
            mb: 2.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
            <Box
              sx={{
                width: 58,
                height: 58,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #2f327d 0%, #1e215a 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "22px",
                fontWeight: 700,
                boxShadow: "0 4px 12px rgba(47, 50, 125, 0.25)",
              }}
            >
              {(details?.first_name?.[0] || "") + (details?.last_name?.[0] || "S")}
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                <Typography sx={{ fontSize: "24px", fontWeight: 700, color: "#0f172a" }}>
                  {details?.first_name} {details?.last_name}
                </Typography>
                {details.profile?.grade?.title && (
                  <Chip
                    label={details.profile?.grade?.title}
                    size="small"
                    sx={{
                      backgroundColor: "#eef2ff",
                      color: "#3730a3",
                      fontWeight: 600,
                      borderRadius: "999px",
                      border: "1px solid #c7d2fe",
                      fontSize: "12px",
                    }}
                  />
                )}
              </Box>
              <Typography sx={{ fontSize: "13px", color: "#64748b", mt: 0.4 }}>
                Student ID: #{details?.id || sid} {details?.email ? `• ${details.email}` : ""} {details?.phone ? `• ${details.phone}` : ""}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* 4-Item Meta Grid */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" },
            gap: 2,
            backgroundColor: "#f8fafc",
            padding: "16px 20px",
            borderRadius: "12px",
            border: "1px solid #f1f5f9",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <SchoolIcon sx={{ fontSize: 22, color: "#2f327d" }} />
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>Grade</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                {details.profile?.grade?.title || "-"}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <SchoolIcon sx={{ fontSize: 22, color: "#2f327d" }} />
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>Institute</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                {instituteList[instituteList.findIndex((item) => item.id == details.profile?.institute)]?.name || "Not specified"}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <PersonIcon sx={{ fontSize: 22, color: "#2f327d" }} />
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>Gender</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                {gender[gender.findIndex((item) => item.id == details.gender)]?.name || "-"}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CalendarTodayIcon sx={{ fontSize: 20, color: "#2f327d" }} />
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500 }}>Date of Birth</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                {details.profile?.dob || "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>

      {/* Counselling packages booked by this student, with status */}
      {details?.packages?.length > 0 && (
        <Box sx={{ width: "100%", marginBottom: "24px" }}>
          <Typography
            sx={{ fontSize: "1.1em", color: "#1e293b", fontWeight: 700, marginBottom: "12px" }}
          >
            Counselling Packages
          </Typography>
          <Stack direction="column" spacing={1.5}>
            {details.packages.map((p) => (
              <Card key={p.id} sx={{ border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.02)", borderRadius: "12px" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                    paddingBottom: "16px !important",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: "bold", color: "#2F327D" }}>
                      {p.name || "Package"}
                    </Typography>
                    <Typography sx={{ fontSize: "0.85em", color: "#64748b", mt: 0.3 }}>
                      {/* "done" = held (report generated); "booked" is what the
                          package has been used for so far. */}
                      {p.sessions_done ?? 0}/{p.sessions_total} sessions done ·{" "}
                      {p.sessions_used} booked
                      {p.sessions_remaining > 0 ? ` · ${p.sessions_remaining} left to book` : ""}
                      {p.expiry_date ? ` · expires ${p.expiry_date}` : ""}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span
                      style={{
                        padding: "4px 14px",
                        borderRadius: 999,
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#0f6e57",
                        background: "#d7f2e9",
                      }}
                    >
                      {p.status}
                    </span>
                    <span
                      style={{
                        padding: "4px 14px",
                        borderRadius: 999,
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#5a4b8a",
                        background: "#ece8f7",
                      }}
                    >
                      {p.payment_status}
                    </span>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      )}

      {/* Guardian & Address 2-Column Section */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2.5,
          marginBottom: "24px",
        }}
      >
        {/* Guardian Card */}
        <Card
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "14px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
            padding: "20px 24px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FamilyRestroomIcon sx={{ color: "#2f327d", fontSize: 22 }} />
              <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>
                Guardian Details
              </Typography>
            </Box>
            {details?.guardian?.[0] && (
              <EditIcon
                sx={{ fontSize: "18px", cursor: "pointer", color: "#64748b", "&:hover": { color: "#2f327d" } }}
                onClick={() => handleClickOpen("guardianDetails", details.guardian[0])}
              />
            )}
          </Box>
          {(!details?.guardian || details?.guardian?.length === 0) ? (
            <Typography sx={{ fontSize: "13px", color: "#94a3b8", fontStyle: "italic", py: 1.5 }}>
              No guardian information added yet.
            </Typography>
          ) : (
            details.guardian.map((gE, idx) => (
              <Box key={idx} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, pt: 1 }}>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Name</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {gE ? `${gE.first_name || ""} ${gE.last_name || ""}` : "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Phone</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {gE?.phone || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Email</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {gE?.email || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Occupation</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {gE?.occupation || "-"}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Card>

        {/* Address Card */}
        <Card
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "14px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
            padding: "20px 24px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocationOnIcon sx={{ color: "#2f327d", fontSize: 22 }} />
              <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>
                Address Details
              </Typography>
            </Box>
            {details?.address?.[0] && (
              <EditIcon
                sx={{ fontSize: "18px", cursor: "pointer", color: "#64748b", "&:hover": { color: "#2f327d" } }}
                onClick={() => handleClickOpen("addressDetails", details.address[0])}
              />
            )}
          </Box>
          {(!details?.address || details?.address?.length === 0) ? (
            <Typography sx={{ fontSize: "13px", color: "#94a3b8", fontStyle: "italic", py: 1.5 }}>
              No address details added yet.
            </Typography>
          ) : (
            details.address.map((addEle, idx) => (
              <Box key={idx} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, pt: 1 }}>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>City</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {addEle?.city || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>State</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {addEle?.state || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Pincode</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {addEle?.zipcode || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Landmark</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1e293b", mt: 0.2 }}>
                    {addEle?.landmark || "-"}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Card>
      </Box>

      {/* Tests Results Section */}
      <Box sx={{ width: "100%", marginBottom: "28px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, marginBottom: "12px" }}>
          <Typography
            sx={{
              fontSize: "1.1em",
              color: "#1e293b",
              fontWeight: 700,
            }}
          >
            Assessment & Test Results
          </Typography>
          <Chip
            label={`${testDet.length} Tests`}
            size="small"
            sx={{ backgroundColor: "#f1f5f9", color: "#475569", fontWeight: 600, fontSize: "12px" }}
          />
        </Box>

        {testDet.length === 0 ? (
          <Card
            sx={{
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "24px",
              textAlign: "center",
              color: "#94a3b8",
            }}
          >
            No assessment test details recorded for this student.
          </Card>
        ) : (
          <Card
            sx={{
              backgroundColor: "#ffffff",
              borderRadius: "14px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
              overflow: "hidden",
            }}
          >
            {testDet.map((testData, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "16px 24px",
                  borderBottom: index < testDet.length - 1 ? "1px solid #f1f5f9" : "none",
                  "&:hover": {
                    backgroundColor: "#f8fafc",
                  },
                  transition: "background-color 0.2s ease",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      backgroundColor: "#eff6ff",
                      color: "#2f327d",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                    }}
                  >
                    {testData.TestType === "aptitude" ? "🧠" : testData.TestType === "interest" ? "🎯" : "📊"}
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "15px",
                        color: "#1e293b",
                        textTransform: "capitalize",
                      }}
                    >
                      {testData.TestType === "achievement" ? "Academics Assessment" : `${testData.TestType} Assessment`}
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#64748b", mt: 0.2 }}>
                      {testData.data.length > 0 ? "Assessment report available" : "No report generated yet"}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  {testData.data.length === 0 ? (
                    <Chip label="No Data" size="small" sx={{ backgroundColor: "#f1f5f9", color: "#94a3b8" }} />
                  ) : (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={(e) => openTestPdf(e, details?.id, testData.TestType)}
                      style={{
                        backgroundColor: "#2f327d",
                        color: "#ffffff",
                        padding: "6px 18px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "13px",
                        textTransform: "none",
                        boxShadow: "0 2px 6px rgba(47, 50, 125, 0.25)",
                        cursor: "pointer",
                      }}
                      sx={{
                        backgroundColor: "#2f327d !important",
                        color: "#ffffff !important",
                        "&:hover": {
                          backgroundColor: "#1e215a !important",
                          boxShadow: "0 4px 10px rgba(47, 50, 125, 0.35) !important",
                        },
                      }}
                    >
                      📄 View Report
                    </Button>
                  )}
                </Box>
              </Box>
            ))}
          </Card>
        )}
      </Box>

      {/* Sessions Section */}
      <Box sx={{ width: "100%", marginBottom: "16px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, marginBottom: "14px" }}>
          <Typography
            sx={{
              fontSize: "1.1em",
              color: "#1e293b",
              fontWeight: 700,
            }}
          >
            Counselling Sessions
          </Typography>
          <Chip
            label={`${details?.sessions?.length || 0}`}
            size="small"
            sx={{ backgroundColor: "#eff6ff", color: "#2f327d", fontWeight: 700, fontSize: "12px" }}
          />
        </Box>
      </Box>

      <Box sx={{ width: "100%" }}>
        {details?.sessions?.map((item, index) => {
          const isExpanded = expandedAccordion === index;
          return (
            <Accordion
              expanded={isExpanded}
              onChange={() => setExpandedAccordion(isExpanded ? false : index)}
              key={index}
              sx={{
                mb: 2,
                borderRadius: "12px !important",
                border: "1px solid #e2e8f0",
                boxShadow: isExpanded ? "0 4px 14px rgba(0,0,0,0.05)" : "0 2px 6px rgba(0,0,0,0.02)",
                "&:before": { display: "none" },
                overflow: "hidden",
                transition: "all 0.2s ease",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#2f327d", fontSize: 24 }} />}
                aria-controls={`panel-${item?.id}-content`}
                id={`panel-${item?.id}-header`}
                sx={{
                  backgroundColor: isExpanded ? "#f8fafc" : "#ffffff",
                  borderBottom: isExpanded ? "1px solid #e2e8f0" : "none",
                  padding: "10px 20px",
                  "&:hover": {
                    backgroundColor: "#f8fafc",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    pr: 1.5,
                    flexWrap: "wrap",
                    gap: "12px 20px",
                  }}
                >
                  {/* Left: ID + Title + Report status */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                    <Chip
                      label={`Session #${item?.id}`}
                      size="small"
                      sx={{
                        backgroundColor: "#f1f5f9",
                        color: "#334155",
                        fontWeight: 700,
                        fontSize: "12px",
                        borderRadius: "6px",
                      }}
                    />
                    <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>
                      {item?.session_name || "Counselling Session"}
                    </Typography>
                    {(sessionGeneratedReports[item.id]?.report_pdf || item?.session_report?.report_pdf) ? (
                      <Chip
                        label="✓ Report Ready"
                        size="small"
                        sx={{
                          backgroundColor: "#dcfce7",
                          color: "#15803d",
                          fontWeight: 700,
                          height: "24px",
                          fontSize: "12px",
                          border: "1px solid #86efac",
                        }}
                      />
                    ) : (
                      <Chip
                        label="Scheduled"
                        size="small"
                        sx={{
                          backgroundColor: "#eff6ff",
                          color: "#1d4ed8",
                          fontWeight: 600,
                          height: "24px",
                          fontSize: "12px",
                        }}
                      />
                    )}
                  </Box>

                  {/* Right: Counsellor, Date, Time */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2.5, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                      <PersonIcon sx={{ fontSize: 16, color: "#94a3b8" }} />
                      <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Counsellor:</Typography>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                        {item?.counsellor ? item?.counsellor : "-"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                      <CalendarTodayIcon sx={{ fontSize: 15, color: "#94a3b8" }} />
                      <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Date:</Typography>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                        {item?.date ? item?.date : "-"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                      <AccessTimeIcon sx={{ fontSize: 15, color: "#94a3b8" }} />
                      <Typography sx={{ fontSize: "12px", color: "#64748b" }}>Time:</Typography>
                      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                        {item?.time_slot?.commence ? item?.time_slot?.commence : "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {(sessionGeneratedReports[item.id]?.report_pdf || item?.session_report?.report_pdf) && (
                  <Box
                    sx={{
                      p: 2.2,
                      mb: 2.5,
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)",
                      border: "1px solid #86efac",
                      boxShadow: "0 2px 8px rgba(16, 185, 129, 0.08)",
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      justifyContent: "space-between",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "8px",
                          backgroundColor: "#16a34a",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "22px",
                        }}
                      >
                        📄
                      </Box>
                      <Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#14532d" }}>
                            {sessionGeneratedReports[item.id]?.report_template_name || item?.session_report?.report_template_name || "Counselling Report"}
                          </Typography>
                          <Chip
                            label="Generated"
                            size="small"
                            sx={{
                              backgroundColor: "#16a34a",
                              color: "#fff",
                              fontWeight: 600,
                              fontSize: "11px",
                              height: "20px",
                            }}
                          />
                        </Box>
                        <Typography variant="body2" sx={{ color: "#15803d", mt: 0.3 }}>
                          Session report has been generated and is ready to download.
                          {(sessionGeneratedReports[item.id]?.created || item?.session_report?.created) &&
                            ` (Generated on: ${sessionGeneratedReports[item.id]?.created || item?.session_report?.created})`}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                      <Button
                        variant="contained"
                        color="success"
                        className="btn-download-pdf"
                        size="small"
                        style={{
                          background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                          backgroundColor: "#16a34a",
                          color: "#ffffff",
                          padding: "8px 20px",
                          borderRadius: "8px",
                          fontWeight: 700,
                          fontSize: "13px",
                          textTransform: "none",
                          boxShadow: "0 3px 10px rgba(22, 163, 74, 0.3)",
                          cursor: "pointer",
                          border: "none",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        sx={{
                          background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important",
                          backgroundColor: "#16a34a !important",
                          color: "#ffffff !important",
                          fontWeight: 700,
                          fontSize: "13px",
                          textTransform: "none",
                          padding: "8px 20px",
                          borderRadius: "8px",
                          boxShadow: "0 3px 10px rgba(22, 163, 74, 0.3)",
                          "&:hover": {
                            background: "linear-gradient(135deg, #15803d 0%, #166534 100%) !important",
                            backgroundColor: "#15803d !important",
                            boxShadow: "0 4px 14px rgba(22, 163, 74, 0.45) !important",
                          },
                        }}
                        onClick={() => {
                          const pdfUrl = sessionGeneratedReports[item.id]?.report_pdf || item?.session_report?.report_pdf;
                          if (pdfUrl) {
                            window.open(pdfUrl, "_blank");
                          }
                        }}
                      >
                        <DownloadIcon sx={{ fontSize: 18, color: "#ffffff" }} />
                        Download / View PDF
                      </Button>
                    </Box>
                  </Box>
                )}

                {/* Pre-picked from the session's package (autoReportFor);
                    changed only when that guess is wrong. */}
                {sessionReport[item.id] && (
                  <TextField
                    select
                    size="small"
                    label="Report"
                    helperText="Picked from the package automatically - change only if it is wrong"
                    value={sessionReport[item.id]}
                    onChange={(e) => handleReportChange(item.id, e.target.value)}
                    sx={{ minWidth: "340px", marginBottom: "20px" }}
                  >
                    {reportsForStudent(item.id).map((report) => (
                      <MenuItem key={report.id} value={report.id}>
                        {report.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                {!sessionReport[item.id] && (
                  <Typography sx={{ fontSize: "0.9em", color: "#999" }}>
                    No report template is set up for this session's package yet
                    (add one under Report Templates).
                  </Typography>
                )}
                {sessionIntake[item.id] && (
                  <Box
                    sx={{
                      border: "1px solid #b7e0dc",
                      background: "#f2faf9",
                      borderRadius: "10px",
                      p: 2,
                      mb: 3,
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, color: "#1F7A78", mb: 0.5 }}>
                      From the student's booking
                    </Typography>
                    {sessionIntake[item.id].prefilled && (
                      <Typography sx={{ fontSize: 14, color: "#333" }}>
                        The concerns they ticked are pre-selected below. Check them
                        and press Submit to keep them.
                      </Typography>
                    )}
                    {sessionIntake[item.id].note && (
                      <Typography sx={{ fontSize: 14, color: "#333", mt: 0.5 }}>
                        <b>In their words:</b> {sessionIntake[item.id].note}
                      </Typography>
                    )}
                  </Box>
                )}
                {(sessionHistory[item.id]?.sessions || []).length > 0 && (
                  <Box
                    sx={{
                      border: "1px solid #c7d6ea",
                      background: "#f4f7fc",
                      borderRadius: "10px",
                      p: 2,
                      mb: 3,
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, color: "#1F3864", mb: 1 }}>
                      Earlier sessions
                    </Typography>
                    {sessionHistory[item.id].sessions.map((s) => (
                      <Typography key={s.label} sx={{ fontSize: 14, mb: 0.75, color: "#333" }}>
                        <b>{s.label}:</b> {s.text}
                      </Typography>
                    ))}
                    {(sessionHistory[item.id].last_homework || []).length > 0 && (
                      <>
                        <Typography sx={{ fontWeight: 700, color: "#1E8770", mt: 1.5, fontSize: 14 }}>
                          Homework set last session (review it below)
                        </Typography>
                        <ul style={{ margin: "4px 0 0", paddingLeft: 20, fontSize: 14 }}>
                          {sessionHistory[item.id].last_homework.map((task) => (
                            <li key={task}>{task}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </Box>
                )}
                {(sessionCategories[item.id] || []).map((cat) => (
                  <DynamicCategorySection
                    key={cat.id}
                    category={cat}
                    questions={categoryQuestions[cat.id] || []}
                    sessionId={item.id}
                    answers={categoryAnswers[cat.id]?.[item.id] || []}
                    onAnswerChange={(sessionId, questionId, choice, answer) =>
                      handleCategoryAnswerChange(
                        cat.id,
                        sessionId,
                        questionId,
                        choice,
                        answer
                      )
                    }
                    onSave={(sessionId) =>
                      saveCategoryAnswers(cat.id, sessionId)
                    }
                    aiText={aiTexts[`${item.id}-${cat.id}`] || ""}
                    CustomComponent={
                      customComponentMap[cat.title] ||
                      ((categoryQuestions[cat.id] || []).length === 0
                        ? customComponentMap["default"]
                        : null)
                    }
                    customComponentProps={{
                      category: cat,
                      sessionId: item.id,
                      userId: details.id,
                      stuProfile:
                        cat.title === "Student Profile"
                          ? testResponce
                          : cat.title === "Judgement"
                          ? judgResponce
                          : cat.title === "Recommendation"
                          ? recoResponce
                          : undefined,
                      area_concern:
                        cat.title === "Area of concern"
                          ? areaResponce
                          : undefined,
                      dream_career:
                        cat.title === "Dream Career Details"
                          ? dreamResponce
                          : undefined,
                    }}
                  />
                ))}
                {sessionReport[item.id] && (
                  <Box
                    sx={{
                      mt: 3,
                      pt: 2,
                      borderTop: "1px dashed #cbd5e1",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="success"
                      className="btn-download-pdf"
                      size="medium"
                      style={{
                        background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                        backgroundColor: "#16a34a",
                        color: "#ffffff",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: 700,
                        fontSize: "14px",
                        textTransform: "none",
                        boxShadow: "0 4px 12px rgba(22, 163, 74, 0.35)",
                        cursor: "pointer",
                        border: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      sx={{
                        background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important",
                        backgroundColor: "#16a34a !important",
                        color: "#ffffff !important",
                        fontWeight: 700,
                        fontSize: "14px",
                        px: 3,
                        py: 1.2,
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(22, 163, 74, 0.35)",
                        textTransform: "none",
                        "&:hover": {
                          background: "linear-gradient(135deg, #15803d 0%, #166534 100%) !important",
                          backgroundColor: "#15803d !important",
                          boxShadow: "0 6px 16px rgba(22, 163, 74, 0.45) !important",
                        },
                      }}
                      onClick={() => handleGenerateSessionReport(item.id, sid)}
                    >
                      <DownloadIcon sx={{ fontSize: 20, color: "#ffffff" }} />
                      Generate & Download Session Report (PDF)
                    </Button>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>

      {/* Bottom Action Section: Career Counselling Report */}
      <Box
        sx={{
          marginTop: "32px",
          marginBottom: "40px",
          padding: "20px 26px",
          backgroundColor: "#ffffff",
          borderRadius: "14px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>
            Career Counselling Comprehensive Report
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#64748b", mt: 0.3 }}>
            Generate and view the combined overall student assessment & counselling report.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="medium"
          style={{
            backgroundColor: "#2f327d",
            color: "#ffffff",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: 700,
            fontSize: "14px",
            textTransform: "none",
            boxShadow: "0 4px 12px rgba(47, 50, 125, 0.3)",
            cursor: "pointer",
            border: "none",
          }}
          sx={{
            backgroundColor: "#2f327d !important",
            color: "#ffffff !important",
            "&:hover": {
              backgroundColor: "#1e215a !important",
              boxShadow: "0 6px 16px rgba(47, 50, 125, 0.45) !important",
            },
          }}
          onClick={() =>
            handleCareerCounsellingReport(
              sid,
              details?.student_test_type
            )
          }
        >
          📄 Generate Career Counselling Report
        </Button>
      </Box>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <EditFieldsForm
          handleClose={handleClose}
          editSection={sectionType}
          editFormDetails={editObject}
          objForForm={objForForm}
        />
      </BootstrapDialog>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default StudentProfile;
export const gender = [
  {
    id: 2,
    name: "Female",
  },
  {
    id: 1,
    name: "Male",
  },
];

export const editSection = [
  {
    type: "userDetails",
    id: 1,
    key: "user",
  },
  {
    type: "guardianDetails",
    id: 2,
    key: "guardian",
  },
  {
    type: "addressDetails",
    id: 3,
    key: "address",
  },
  {
    type: "sessionDetails",
    id: 4,
    key: "sessions",
  },

  {
    type: "sessionNotes",
    id: 5,
    key: "notes",
  },

  {
    type: "bookSlot",
    id: 6,
    key: "bookSlot",
  },
];
